import $ from 'jquery';
import $script from 'scriptjs';
import ComplementaryProducts from '@pixelunion/pxs-complementary-products';
import ProductDetails from '../components/ProductDetails';

export default class StaticProduct {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.complementaryProducts = null;

    $script($('[data-scripts]').data('shopify-api-url'), () => {
      this.productDetails = new ProductDetails(section);
      if (this.data.complementary_product_limit) {
        this.complementaryProducts = new ComplementaryProducts({
          sectionEl: this.el,
          sectionId: section.id,
          productId: this.data.product_id,
          productRecommendationsRoute: window.Theme.routes.product_recommendations_url,
          includeIndicatorDots: true,
          limit: this.data.complementary_product_limit,
        });
      }
    });
  }

  onSectionUnload() {
    this.productDetails.unload();
    if (this.complementaryProducts) {
      this.complementaryProducts.unload();
    }
  }
}
